import { render, staticRenderFns } from "./StudyPlansList.vue?vue&type=template&id=68042978&"
import script from "./StudyPlansList.vue?vue&type=script&lang=js&"
export * from "./StudyPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports